import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useHeaderContentStore } from '@/store';

/**
 * Lets a page render its own content inside MainLayout's Header, in place of
 * the default back-link area — MainLayout's avatar/account menu stays put on
 * the right, so pages never need to reimplement it. Re-registers on every
 * render (no dep array) since callers typically pass JSX that closes over
 * live state (a running timer, streaming flags, etc.).
 */
export const usePageHeaderContent = (content: ReactNode): void => {
  const setHeaderContent = useHeaderContentStore((s) => s.setHeaderContent);
  const clearHeaderContent = useHeaderContentStore((s) => s.clearHeaderContent);

  useEffect(() => {
    setHeaderContent(content);
  });

  useEffect(() => () => clearHeaderContent(), [clearHeaderContent]);
};

export default usePageHeaderContent;
